(() => {
  if (window.CistaNativeGallery) return;
  window.CistaNativeGallery = true;
  document.addEventListener('cista:choice-change', async (event) => {
    const purchase = event.target.closest?.('cista-purchase');
    const product = purchase?.closest('product-info');
    const gallery = product?.querySelector('media-gallery');
    const choice = event.detail?.choice;
    if (!gallery || !['small', 'large', 'set'].includes(choice)) return;
    const token = Symbol();
    gallery.cistaChoiceToken = token;
    await customElements.whenDefined('media-gallery');
    if (!gallery.isConnected || gallery.cistaChoiceToken !== token) return;
    const home = product.closest('cista-shop');
    const mediaKey = choice === 'set' ? 'Bundle' : choice[0].toUpperCase() + choice.slice(1);
    const homeKey = choice[0].toUpperCase() + choice.slice(1);
    let mediaId = gallery.dataset['cista' + mediaKey + 'Media'] || home?.dataset['media' + homeKey];
    if (choice !== 'set') {
      const size = choice === 'small' ? '60L' : '120L';
      const centered = gallery.querySelector('[id^="GalleryViewer"] [data-media-id] img[src*="CISTA-' + size + '-three-quarter-centered"]');
      mediaId = centered?.closest('[data-media-id]')?.dataset.mediaId || mediaId;
    }
    const slide = mediaId && gallery.querySelector('[id^="GalleryViewer"] [data-media-id="' + mediaId + '"]');
    if (slide && !slide.classList.contains('is-active')) gallery.setActiveMedia(mediaId, false, { scrollPage: false });
  });
})();
